<div class="date-chip" [class.is-tba]="!value">
    <ng-container *ngIf="value; else tba">
        <span class="chip-day">{{ value | date: "EEE" }}</span>
        <span class="chip-num">{{ value | date: "d" }}</span>
        <span class="chip-month">{{ value | date: "MMM" }}</span>
    </ng-container>
    <ng-template #tba>
        <span class="chip-num tba-mark" aria-hidden="true">?</span>
        <span class="chip-month">TBA</span>
    </ng-template>
</div>
